import React, { useEffect, useMemo, useState } from "react";
import styles from './index.module.scss'
import { Adnetworks } from "../../../AFP/Constants";
import { bApiV8 as api } from "../../../../API/BeaconAPI";
import { TickIcon } from "../../../../SVG/TickIcon";
import { SearchIcon } from "../../../../SVG/SearchIcon";
import Loader from "../../../../SharedComponents/Loader/Loader";
import { loadOptions } from "./loadingOption";
import { AsyncPaginate } from "react-select-async-paginate";

const Table1 = () => {
    const websiteID = api.getWebsiteId();
    const [showDialog, setShowDialog] = useState(false);
    const [conState, setConState] = useState([]);
    const [update, setUpdate] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleDisconnect = (option) => {
        setLoading(true);
        api.DELETE(`2.0/connection/${option.connectionID}`).then(res => {
            setUpdate(!update);
            setLoading(false);
        }).catch((error) => {
            setUpdate(!update);
            setLoading(false);
        });

    }
    const getAllData = (url, item) => new Promise((resolve, reject) => {
        api.GET(`2.0/website/${websiteID}/connection/${url}`).then(res => {
            resolve(
                { result: res.response, item }
            );
        }).catch((error) => {
            resolve(
                { result: [], item }
            );
        });
    });

    useMemo(() => {
        const aPromises = []
        setLoading(true);
        Adnetworks.map(i => aPromises.push(getAllData(i.connectionURL, i)));
        Promise.all(aPromises).then((args) => {
            const aTemp = []
            args.map(m => {
                    let result = m.result;
                    let item = m.item
                    aTemp.push({
                        name: result?.display_name || null,
                        label: item?.label,
                        connectionID: result?.connection_id,
                        token_for: item?.connectionURL,
                        accountID: result?.account_id,
                        showConnection: !!item?.account_id,
                        invalidated: result?.invalidated || false,
                        invalidatedDate: result?.invalidatedDate || null,
                        invalidatedMessage: result?.invalidatedMessage || null,
                        icon: item.icon,
                        connectorHidden: item.connectorHidden !== undefined ? item.connectorHidden : false
                    })
            });
            setConState(aTemp)
            setLoading(false);
        }).catch((err) => {
            console.error("Ad network paging err", err)
        });

    }, [update]);

    return (<>
        {showDialog ? <Dialog data={conState} onClose={() => {
            setShowDialog(false);
            setUpdate(!update)
        }} /> : null}
        <div className={styles['main']}>
            <div className={styles['flex-header']}>
                <h3>Your Ad Network Connections</h3>
                {loading ? null :
                    <div className={styles['button']} onClick={() => { setShowDialog(true) }}>Add Connection</div>
                }
            </div>
            {loading ? <Loader className={'loader' + ' ' + styles['loader-animation']} />
                : <div className={styles['table']}>
                    {conState.map((i, j) => {
                        if (!i.connectorHidden) {
                            return (i.connectionID ?
                                <div key={j} className={styles['flex'] + ' ' + (loading ? styles['loader'] : '')}>
                                    <div className={styles['text']}>{i.label || '-'}</div>
                                    {!i.invalidated ? <div className={styles['text']}>{i.name}</div> : <div className={styles['text'] + ' ' + styles['error']}>This account has been invalidated on {new Date(i.invalidatedDate).toLocaleDateString()} with error: "{i.invalidatedMessage}". Please reconnect.</div>}
                                    <div className={styles['text']}>{i.accountID ? 'connected' : 'disconnected'}</div>
                                    <div className={styles['text']} style={{ textAlign: "right", paddingBottom: 5 }}>
                                        <button onClick={() => { handleDisconnect(i) }} className={styles['button'] + ' ' + styles['remove']}>Remove</button>
                                    </div>
                                </div> : null)
                        }
                    })}
                </div>}
        </div>
    </>)
}


const SuccesfullyConected = ({ selectedOption, onClose }) => {
    return (
        <div className={styles["successfull-connected-section"]}>
            <TickIcon />
            <h3 className={styles["selected-option"]}>Successfully Connected</h3>
            <button onClick={() => onClose()} className={styles["okay-btn"]}>Okay</button>
        </div>
    )
};

const Dropdown = ({ header, options = [], api, isClearable, isSearchable, handleOptionClick, id }) => {
    const adNetworks = options.map((item, index) => ({ ...item, id: index, label: item.label }))
    const data = loadOptions(api, id);
    const option = header === "Select Ad Network" ? { options: adNetworks, hasMore: false } : data;

    return (
        <div className={styles["dropdown-container"]}>
            <AsyncPaginate
                className="basic-single"
                classNamePrefix="select"
                placeholder={header}
                options={adNetworks}
                isClearable={isClearable}
                isSearchable={isSearchable}
                loadOptions={option}
                onChange={(selectedOption) => handleOptionClick(selectedOption)}
                debounceTimeout={300}
                additional={{
                    page: 1,
                }}
            />
        </div>
    );
}
const Dialog = ({ onClose, data }) => {
    const websiteID = api.getWebsiteId();
    let page = 1;
    const [selectedOption, setSelectedOption] = useState(null);
    const [accounts, setAccounts] = useState([]);
    const [partners, setPartners] = useState([]);
    const [search, setSearch] = useState("");
    const [showSearch, setShowSearch] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const [fetchAccounts, setFetchAccounts] = useState(false);
    const [couldNotLoad, setCouldNotLoad] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [curConnectionID, setCurConnectionID] = useState(0);
    const [accountConnection, setAccountConnection] = useState(true);
    const [createConnectionLoading, setCreateConnectionLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [status, setStatus] = useState(null);
    const [initalGetConnection, setInitalGetConnection] = useState(false);
    let connDialog = null;
    let prevURL = null;
    let platforms = Adnetworks;

    useEffect(() => {
        // Fetch available partners
        api.GET(`2.0/partners`).then(res => {
            setPartners(res.response || []);
        }).catch(error => {
            console.error("Error fetching partners:", error);
        });
    }, []);

    const receiveMessage = (msg) => {
        //console.debug(msg)
    }

    const processAccounts = (elem) => {
        setShowSearch(selectedOption.adnetwork.label === "Google");
        let accounts = [];
        for (let i in elem?.accounts) {
            const item = elem.accounts[i];
            if (item?.children) {
                for (const key in item.children) {
                    const val = item.children[key];
                    if (!accounts.find((a) => a.id === val.id)) {
                        accounts.push(val);
                    }
                }
            } else {
                if (!accounts.find((a) => a.id === item.id)) {
                    accounts.push(item);
                }
            }
        }
        setAccounts(accounts);
        if (accounts.length === 0) {
            setCouldNotLoad(true);
        } else {
            setCouldNotLoad(false);
        }
    }

    // When ad network option changes
    useEffect(() => {
        let option = selectedOption?.adnetwork || {};
        if ((option?.connectionID && !option?.accountID)) {
            getAccounts(option?.connectionID).then(elem => {
                processAccounts(elem);
            }).catch(error => {
                setStatus({ msg: error, error: true });
            })
        } else if (!option?.connectionID) {
            handleConnect(option);
        }
    }, [selectedOption?.adnetwork])

    const handlePartnerClick = (partner) => {
        setSelectedOption({ partner });
        setShowSearch(false);
        setAccounts(null);
        setInitalGetConnection(false);
        setSelectedOption({ ...selectedOption, adnetwork: null });
    };

    const handleOptionClick = (option) => {
        setShowConfirm(false);
        setShowSearch(false);
        setSearch("");
        setAccounts(null);
        setInitalGetConnection(false);
        if (option === null) {
            setSelectedOption({ ...selectedOption, adnetwork: null });
        } else {
            setSelectedOption({ ...selectedOption, adnetwork: option });
        }
    };

    // const handleAccountClickOld = (option) => {
    //     setShowConfirm(true);
    //     setSelectedOption({ ...selectedOption, account: { ...selectedOption.account, id: option.value } });
    //     return false;
    // }

    const handleAccountChange = (evt) => {
        const selectedIndex = evt.target.selectedIndex;
        const selectedOpt = evt.target.options[selectedIndex];
        const accountId = selectedOpt.value;

        setShowConfirm(true);
        setSelectedOption({ ...selectedOption, account: { ...selectedOption.account, id: accountId } });
        return false;
    }


    const getAccountData = (url) => new Promise((resolve, reject) => {
        if (url) {
            api.GET(`2.0/website/${websiteID}/connection/${url}`).then(res => {
                if (res?.responseType === "error") {
                    setErrorMessage(res.message)
                }
                resolve(
                    { result: res.response }
                );

            }).catch((error) => {
                resolve(
                    { result: [] }
                );
            });
        }

    });

    const confirmConnection = () => {
        let connectionID = selectedOption?.adnetwork?.connectionID || curConnectionID;
        new Promise((resolve, reject) => {
            api.POST(`2.0/connection/${connectionID}`, {
                "website_id": Number(websiteID),
                "token_for": selectedOption?.adnetwork?.connectionURL,
                "account_id": selectedOption?.account?.id,
                "login_id": selectedOption?.account?.loginId
            }).then(res => {
                resolve(
                    res.response
                );
                setStatus({ success: true })
            }).catch((error) => {
                reject(
                    []
                );
                setStatus({ error: true })
            });
        })
    }

    useEffect(() => {
        getAccountData(selectedOption?.adnetwork?.connectionURL).then(({ result }) => {
            setCurConnectionID(result?.connection_id);
            getAccounts(result?.connection_id, search).then(elem => {
                processAccounts(elem);
            })
        }).catch(error => {
            console.error("Error fetching account data:", error);
            setShowMessage(true);
        })

    }, [fetchAccounts]);

    const getAccounts = (connectionID, search = "", page = 1) => new Promise((resolve, reject) => {
        connectionID = connectionID ?? selectedOption?.adnetwork?.connectionID;
        if (connectionID && connectionID != "") {
            if (!initalGetConnection) {
                setCreateConnectionLoading(true)
            }
            const url = (search === "") ? `2.0/connection/${connectionID}/accounts` : `2.0/connection/${connectionID}/accounts/${search}`;
            api.GET(url, { page: page }).then(res => {
                let accounts = res.response;
                if (typeof res.response[0]?.children !== "undefined" && res.response[0]?.children.length > 0) {
                    setSelectedOption({ ...selectedOption, account: { loginId: res.response[0].children[0].loginId } });
                }
                setInitalGetConnection(true);
                setCreateConnectionLoading(false);
                resolve(
                    { accounts: accounts, accountsExist: true }
                );
            }).catch((error) => {
                console.error(error);
                setCreateConnectionLoading(false)
                if (error.message === "Network Error") {
                    setAccountConnection(false)
                }
            })
        }
    });


    const handleConnect = (option) => {
        if (option?.connectionURL) {
            createConnection(option.connectionURL).then(url => {
                var x = window.screen.width / 2 - 500 / 2;
                var y = window.screen.height / 2 - 600 / 2;
                window.removeEventListener('message', receiveMessage);
                setShowMessage(true);
                if (connDialog === null || connDialog.closed) {
                    connDialog = window.open(url, 'connDialog', `toolbar=no, menubar=no, width=500, height=600, status=no, left=${x}, top=${y}`);
                } else if (prevURL !== url) {
                    connDialog = window.open(url, 'connDialog', `toolbar=no, menubar=no, width=500, height=600, status=no, left=${x}, top=${y}`);
                    connDialog.focus();
                } else {
                    connDialog.focus();
                }
                if (connDialog?.closed) {
                    alert('done');
                }
                var timer = setInterval(function () {
                    if (connDialog.closed) {
                        clearInterval(timer);
                        // setLoading(false);
                        setFetchAccounts(!fetchAccounts);
                        setShowMessage(false)
                    }
                }, 500);
                window.addEventListener('message', event => receiveMessage(event), false);
                prevURL = url;
            })
        }
    }

    const createConnection = (network) => new Promise((resolve, reject) => {
        setCreateConnectionLoading(true)
        api.POST(`2.0/connection`, {
            "website_id": Number(websiteID),
            "token_for": network
        }).then(res => {
            resolve(
                res.response
            );
            setCreateConnectionLoading(false)
        }).catch((error) => {
            resolve(
                []
            );
        });
    });

    const handleTextSearch = (e) => {
        setIsSearching(true);
        setAccounts(null);
        setCouldNotLoad(false);
        getAccounts(curConnectionID, search).then(elem => {
            processAccounts(elem);
            setIsSearching(false);
        });
    }

    return (
        <div className={styles["modal-bg"]}>
            <div className="login-form" style={{ height: "50vh" }}>
                <div className={styles["modal-header"]}>
                    <h3 className={styles["modal-heading"]}> Add New Connection</h3>
                    <p className={styles["close-mark"]} onClick={() => onClose()}  >X</p>
                </div>
                {!status?.success ? <>
                    {accountConnection && <Dropdown header={"Select Ad Network"}
                        options={platforms} isClearable={true} isSearchable={true}
                        handleOptionClick={handleOptionClick} />}
                    {(createConnectionLoading) && <Loader />}
                    {errorMessage !== "" && <div className={styles['complete-auth-message']}>{errorMessage}</div>}
                    {(selectedOption?.adnetwork?.connectionURL === 'dv360' && accountConnection) && (
                        <Dropdown header={"Select Partner"} options={partners} isClearable={true} isSearchable={false} handleOptionClick={handlePartnerClick} />
                    )}
                    {showSearch && (
                        <div className={styles["add-account-search"]}>
                            <input type="text" placeholder="Search" onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => (e.key === "Enter") ? handleTextSearch(e) : {}} />
                            <button onClick={handleTextSearch}><SearchIcon /></button>
                        </div>
                    )}
                    {isSearching && <Loader />}
                    {(accounts?.length && selectedOption?.adnetwork) ?
                        <div className={styles["select-account"]}>
                            <select onChange={handleAccountChange}>
                                <option value="">Select Account</option>
                                {accounts.map((account) => (
                                    <option key={account.id} value={account.id}>{account.name}</option>
                                ))}
                            </select>
                        </div>
                        : (couldNotLoad && <div className={styles['complete-auth-message']}>Unable to list accounts, please try searching.
                        </div>)}
                    {showConfirm ? <button className={styles['confirm-button']} onClick={confirmConnection} >Confirm</button> :
                        showMessage ? <div className={styles['complete-auth-message']}>Please complete the authorisation process
                            <div>(opens in a new browser window)</div>
                        </div> : null}
                </> :
                    <SuccesfullyConected onClose={onClose} selectedOption={selectedOption} />}

                <>
                    {
                        !accountConnection &&
                        <>
                            <div style={{ padding: "0.5rem" }}>
                                Sorry, we’re having trouble getting your account details.
                                <p>
                                    This is often because the account you are using to connect, does not have access to {selectedOption?.adnetwork?.label} account.
                                    Please confirm the account you have used to sign in has access to the {selectedOption?.adnetwork?.label} account and try again.
                                </p>

                                <p>If you believe this is incorrect, contact our support team.</p>
                            </div>
                            <button className={styles["close-button"]} onClick={() => onClose()} >Close</button>
                        </>

                    }

                </>

            </div>
        </div>
    )
}

export default Table1;
